

const detail = () =>
{

    const btn = document.querySelector('.js-open__index');
    if (!btn) return;

    btn.addEventListener('click', () => {
        document.querySelectorAll('.is-hidden')
            .forEach(el => el.classList.remove('is-hidden'));
        btn.remove(); // ボタンを消す
    });
}

export default detail;
